import { theme } from './../../redux/theme/actions'
import { useAppDispatch } from "../../hooks/hooks";
import AddEditTheme from "../../models/AddEditTheme";
const ThemeDesigner = () => {
	const dispatch = useAppDispatch();
	const handleAddTheme = () => {
		dispatch(theme.set({ addTheme: 'open' }))
	}
	return (
		<div className="flex flex-col items-center w-full h-[65vh] mt-10">
			<AddEditTheme />
			<div className="flex flex-row w-full">
				<div className="flex items-start w-full">
					<div className="text-2xl font-semibold mx-5 my-2">UI Theme Designer</div>
				</div>
				<div className="flex flex-row item-end space-x-2">
					<button
						onClick={() => handleAddTheme()}
						className="bg-[#0071F2FF] text-white px-2 py-1 text-[10px] font-bold rounded w-[150px] h-6">
						Create a New Theme
					</button>
					<button className="bg-[#CAD0D5FF] text-black px-2 py-1 text-[10px] font-bold rounded w-[150px] h-6">
						Import Theme
					</button>
				</div>
			</div>
			<div className="flex flex-row w-full justify-end items-center px-5">
				<div className="flex justify-start ">
					<input type="text"
						placeholder="search your custom theme"
						className="bg-gray-100 italic text-xs w-[300px] p-1 rounded" />
				</div>
				<div className="flex flex-row item-end justify-end w-2/3">
					<button className="text-[#0071F2FF] px-2 py-1 text-[12px] font-bold rounded  h-6">
						Edit
					</button>
					<button className="text-[#0071F2FF] px-2 py-1 text-[12px] font-bold rounded  h-6">
						Publish
					</button>
					<button className="text-[#0071F2FF] px-2 py-1 text-[12px] font-bold rounded  h-6">
						Export
					</button>
					<button className="text-[#0071F2FF] px-2 py-1 text-[12px] font-bold rounded  h-6">
						Delete
					</button>
					<button className="text-[#0071F2FF] px-2 py-1 text-[12px] font-bold rounded  h-6">
						Rename
					</button>
					<button className="text-[#0071F2FF] px-2 py-1 text-[12px] font-bold rounded  h-6">
						Duplicate
					</button>
				</div>
			</div>
			<div className="w-full px-3 my-2">
				<div className="w-full bg-white border rounded-lg p-4">
					<div className="w-full bg-gray-100 border rounded-lg flex justify-between items-end px-4 py-2 mb-4">
						<div className="pb-2">
							<p className="font-semibold text-xl w-[150px]">Quarz Dark</p>
							<p className="text-xs text-black text-opacity-40 font-normal">Digiit Theme</p>
						</div>
						<div className="flex flex-col justify-center item-center w-max border-x border-y border-black p-1 px-3 space-x-2">
							<div className="">
								<button className="h-4 w-4 border-x border-y  bg-[#EC8B46FF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y  bg-[#EC8B46FF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y  bg-[#FFFFFFFF] mr-1">

								</button>

								<button className="h-4 w-4 border-x border-y bg-[#EFF4F9FF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y bg-blue-100 mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y  bg-[#7A5100FF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y bg-[#7A5100FF] mr-1">

								</button>
							</div>
							<div className="text-xs text-center font-semibold">Earthy & Soft Tones</div>
						</div>
						<div className="flex flex-col space-y-2 justify-end item-end w-max">
							<button className="bg-[#819F84FF] text-black px-2  text-[10px]  font-bold rounded w-max h-4">Published</button>
							<button className="bg-[#CAD0D5FF] text-black px-2 py-1 text-[10px]  font-bold rounded w-[100px] h-6">Set As a Default</button>
						</div>
					</div>
					<div className="w-full bg-gray-100 border rounded-lg flex justify-between items-center px-4 py-2 mb-4">
						<div>
							<p className="font-semibold text-xl w-[150px]">Quarz Light</p>
							<p className="text-xs text-black text-opacity-40 font-normal">Digiit Theme</p>
						</div>
						<div className="flex flex-col justify-center item-center w-max border-x border-y border-black p-1 px-3 space-x-2">
							<div className="">
								<button className="h-4 w-4 border-x border-y bg-[#91C8F6FF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y bg-[#91C8F6FF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y bg-[#29313AFF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y bg-[#354A5FFF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y bg-[#1C2228FF] bg-opacity-40 mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y bg-[#FAFAFAFF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y  bg-[#91C8F6FF] mr-1">

								</button>
							</div>
							<div className="text-xs text-center font-semibold">Dark & Grovy</div>
						</div>
						<div className="flex flex-col space-y-2 justify-end item-end w-max">
							<button className="bg-[#FDBA74FF] text-black px-2  text-[10px]  font-bold rounded w-max h-4">Under Review</button>
							<button className="bg-[#CAD0D5FF] text-black px-2 py-1 text-[10px]  font-bold rounded w-[100px] h-6">Set As a Default</button>
						</div>
					</div>
					<div className="w-full bg-gray-100 border rounded-lg flex justify-between items-center px-4 py-2 mb-4">
						<div>
							<p className="font-semibold text-xl w-[150px]">Horizon</p>
							<p className="text-xs text-black text-opacity-40 font-normal">Digiit Theme</p>
						</div>
						<div className="flex flex-col justify-center item-center w-max border-x border-y border-black p-1 px-3 space-x-2">
							<div className="">
								<button className="h-4 w-4 border-x border-y bg-[#9C89B8FF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y bg-[#F0A6CAFF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y bg-[#EFC3E6FF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y bg-[#F0E6EFFF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y bg-[#B9BEDDFF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y bg-[#9D8289FF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y  bg-[#6D6975FF] mr-1">

								</button>
							</div>
							<div className="text-xs text-center font-semibold">Peach Crayola</div>
						</div>
						<div className="flex flex-col space-y-2 justify-end item-end w-max">
							<button className="bg-blue-300 text-black px-2  text-[10px]  font-bold rounded w-max h-4">Design</button>
							<button className="bg-[#CAD0D5FF] text-black px-2 py-1 text-[10px]  font-bold rounded w-[100px] h-6">Set As a Default</button>
						</div>
					</div>
					<div className="w-full bg-gray-100 border rounded-lg flex justify-between items-center px-4 py-2 mb-4">
						<div>
							<p className="font-semibold text-xl w-[150px]">Lemon Chiffon</p>
							<p className="text-xs text-black text-opacity-40 font-normal">Digiit Theme</p>
						</div>
						<div className="flex flex-col justify-center item-center w-max border-x border-y border-black p-1 px-3 space-x-2">
							<div className="">
								<button className="h-4 w-4 border-x border-y bg-[#FFC09FFF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y bg-[#FFEE94FF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y bg-[#FCF6C7FF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y bg-[#A0CED9FF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y bg-[#ADF7B6FF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y bg-[#809BCEFF] mr-1">

								</button>
								<button className="h-4 w-4 border-x border-y  bg-[#95B8D1FF] mr-1">

								</button>
							</div>
							<div className="text-xs text-center font-semibold">Light Blue Pastel</div>
						</div>
						<div className="flex flex-col space-y-2 justify-end item-end w-max">
							<button className="bg-[#819F84FF] text-black px-2  text-[10px]  font-bold rounded w-max h-4">Published</button>
							<button className="bg-[#CAD0D5FF] text-black px-2 py-1 text-[10px]  font-bold rounded w-[100px] h-6">Set As a Default</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ThemeDesigner;


